// extracted by mini-css-extract-plugin
export var messageSideLeft = "_r5-1";
export var messageSideRight = "_r5-2";
export var orderLookupBubbleContainer = "_r5-0";
export var submitButton = "_r5-3";